module.exports = __webpack_public_path__ + "fonts/NHaasGroteskTXPro-65Md.3d6fde9.woff2";